import coreAPIInstance from "./coreApiInstance";

export const typesensePublishesAPIs = {
  getTypesensePublishes: ({ payload }) => coreAPIInstance.post(`/api/v1/typesense/filter.publishes`, payload),
};
